import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
class DiptychImageText extends Component {
    _descriptionOpened = false;
    get descriptionOpened() {
        return this._descriptionOpened;
    }
    set descriptionOpened(value) {
        this._descriptionOpened = value;
        this.translateDescription(value);
    }
    bindEvents(add) {
        const method = bindMethod(add);
        if (this.refs.viewMore)
            this.refs.viewMore[method]('click', (e) => this.toggleDescription(e));
        if (this.refs.viewLess)
            this.refs.viewLess[method]('click', (e) => this.toggleDescription(e));
    }
    toggleDescription = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.descriptionOpened = !this.descriptionOpened;
    };
    translateDescription = (value) => {
        this.refs.overlay.classList.toggle('visible', value);
        this.refs.text.classList.toggle('revealed');
        const buttonContent = this.refs.viewMore.innerText;
        this.refs.viewMore.innerText = this.refs.viewMore.dataset.toggle;
        this.refs.viewMore.dataset.toggle = buttonContent;
    };
}
export default DiptychImageText;
